/**
 * Per-request `<html lang>` resolver — vike-react consumes this via
 * `getHeadSetting('lang', pageContext)` and injects it into the HTML
 * template. Lives in its own file because Vike forbids runtime hooks
 * inside `+config.ts` (see https://vike.dev/error/runtime-in-config).
 *
 * Source of truth is `apps/web/src/lib/i18n/locales.ts` — this hook
 * just looks up the IETF tag (e.g. `zh-Hans-CN` for the `zh-CN` code).
 */

import { getDescriptor, isLocaleCode } from "#/lib/i18n/locales.js";

export default function lang(pageContext: { locale?: string }): string {
  const code = pageContext.locale;
  if (code && isLocaleCode(code)) {
    return getDescriptor(code).htmlLang;
  }
  return "en";
}
